import React, {
    useEffect,
    useState
} from 'react';
import {
    useNavigate,
    useLocation
} from 'react-router-dom'; import UserController from '../../api/user/UserController';
import './PaymentSuccess.css';
import axios from 'axios';
import moment from 'moment-timezone';

const PaymentSuccess = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading,
        setIsLoading] = useState(true);
    const [error,
        setError] = useState(null);

    useEffect(() => {
        const handlePaymentSuccess = async () => {
            const queryParams = new URLSearchParams(location.search); const userId = queryParams.get('userId');
            const amount = parseFloat(queryParams.get('amount'));
            const type = queryParams.get('type'); // yeni parametr
            const bannerId = queryParams.get('bannerId');

            if (!type) {
                setError('Ödəniş növü (type) tapılmadı.');
                setIsLoading(false);
                return;
            }
            if (type === 'balansmototaksiaz') {
                if (!userId || isNaN(amount)) {
                    setError('Parametrlər düzgün deyil.');
                    setIsLoading(false);
                    return;
                }

                try {
                    const existingUser = await UserController.getUserById(userId);
                    const newBalance = (existingUser.balance || 0) + amount;
                    const updatedUser = {
                        ...existingUser,
                        balance: newBalance,
                    };

                    await UserController.updateUser(userId, updatedUser);
                    setIsLoading(false);
                } catch (err) {
                    console.error("Balans artırılarkən xəta:", err);
                    setError('Balans artırıla bilmədi.');
                    setIsLoading(false);
                }
            }

            // 🟡 Placeholder for other types (gələcəkdə buraya əlavə edə bilərsən):
            else if (type === 'balansmototaksi') {
                if (!userId || isNaN(amount)) {
                    setError('Parametrlər düzgün deyil.');
                    setIsLoading(false);
                    return;
                }

                try {
                    // Kuryer məlumatlarını əldə et
                    const courierResponse = await axios.get(`https://mototaksi.az:8989/api/v7/courier/${userId}`);
                    const courier = courierResponse.data;

                    const newBalance = (courier.balance || 0) + amount;

                    const updatedCourier = {
                        ...courier,
                        balance: newBalance
                    };

                    // Güncəllə
                    await axios.put(`https://mototaksi.az:8989/api/v7/courier/${userId}`, updatedCourier);

                    setIsLoading(false);
                } catch (err) {
                    console.error("Kuryer balans artırılarkən xəta:", err);
                    setError('Kuryer balansı artırıla bilmədi.');
                    setIsLoading(false);
                }
            } else if (type === 'abuneliksifarisqrupu') {
                try {
                    const days = parseInt(queryParams.get('days'), 10);

                    if (!userId || !days || days <= 0) {
                        setError('Abunəlik parametrləri düzgün deyil.');
                        setIsLoading(false);
                        return;
                    }

                    const userRes = await axios.get(`https://mototaksi.az:9898/api/v5/user/${userId}`);
                    const existingUser = userRes.data;

                    const TZ = 'Asia/Baku';
                    const now = moment.tz(TZ);

                    // 👉 həmişə növbəti ayın 1-i
                    let start = moment.tz(TZ).date(1).add(1, 'month'); // gələn ayın 1-i

                    // əgər istifadəçinin aktiv subu varsa və gələcəkdirsə → onun üzərindən get
                    if (existingUser?.expiryDate) {
                        const current = moment(existingUser.expiryDate).tz(TZ);

                        if (current.isValid() && current.isAfter(now)) {
                            start = current.clone().add(1, 'month').date(1);
                        }
                    }

                    const newExpiryDate = start.toDate();

                    await axios.put(`https://mototaksi.az:9898/api/v5/user/${userId}`, {
                        isSub: true,
                        expiryDate: newExpiryDate,
                    });

                    setIsLoading(false);
                } catch (err) {
                    console.error("Abunəlik xəta:", err);
                    setError('Abunəlik aktivləşdirilə bilmədi.');
                    setIsLoading(false);
                }
            } else if (type === 'abunelikmototaksi') {
                try {
                    const days = parseInt(queryParams.get('days'), 10);
                    if (!userId || !days || days <= 0) {
                        setError('Moto Taksi abunəlik parametrləri düzgün deyil.');
                        setIsLoading(false);
                        return;
                    }

                    // Mövcud istifadəçi məlumatını çəkək ki, köhnə motoTaksiExpiryDate üzərinə əlavə edək
                    const userRes = await axios.get(`https://mototaksi.az:9898/api/v5/user/${userId}`);
                    const existingUser = userRes?.data;

                    const TZ = 'Asia/Baku';
                    const now = moment.tz(TZ);

                    // Əgər artıq motoTaksiExpiryDate varsa və gələcək tarixdirsə, onun üzərinə gün əlavə edək
                    const currentMotoExp = existingUser?.motoTaksiExpiryDate
                    ? moment(existingUser.motoTaksiExpiryDate).tz(TZ): null;

                    const base = (currentMotoExp && currentMotoExp.isValid() && currentMotoExp.isAfter(now))
                    ? currentMotoExp: now.clone();

                    // ✅ DATE obyektini göndər (string yox)
                    const newMotoExpiryDate = base.clone().add(days, 'days').toDate();

                    const res = await axios.put(`https://mototaksi.az:9898/api/v5/user/${userId}`, {
                        isSubMotoTaksi: true,
                        motoTaksiExpiryDate: newMotoExpiryDate,
                    });

                    console.log('MotoTaksi PUT OK', res.status, res.data);
                    setIsLoading(false);
                } catch (err) {
                    console.error("MotoTaksi abunəlik aktivləşdirilərkən xəta:", {
                        status: err?.response?.status,
                        data: err?.response?.data,
                        msg: err?.message
                    });
                    setError('MotoTaksi abunəlik aktivləşdirilə bilmədi.');
                    setIsLoading(false);
                }
            } else if (type === 'bannersifarisqrupu') {

                if (!bannerId) {
                    setError('Banner ID tapılmadı.');
                    setIsLoading(false);
                    return;
                }

                try {
                    await axios.put(`https://mototaksi.az:9898/api/v5/banner/${bannerId}`, {
                        isDisable: false
                    });

                    setIsLoading(false);
                } catch (err) {
                    console.error("Banner aktivləşdirilərkən xəta:", err);
                    setError('Banner aktivləşdirilə bilmədi.');
                    setIsLoading(false);
                }
            }

        };

        handlePaymentSuccess();
    },
        [location.search]);

    return (
        <div className="payment-success-container">
            <div className="payment-success-card">
                <div className="icon-checkmark">
                    ✔
                </div>
                <h1>Ödəniş Uğurludur</h1>
                {isLoading ? (
                    <p>
                        Balans yenilənir...
                    </p>
                ): error ? (
                    <p style={ { color: 'red' }}>
                        {error}
                    </p>
                ): (
                    <p>
                        Təşəkkür edirik! Ödənişiniz uğurla tamamlandı.
                    </p>
                )}
                <button className="go-home-btn" onClick={() => navigate('/')}>
                    Ana səhifəyə qayıt
                </button>
            </div>
        </div>
    );
};

export default PaymentSuccess;
